import React from 'react'
import { arrayOf, bool, shape, func } from 'prop-types'
import BrandLoader from '../../BrandLoader/BrandLoader'

const VehicleOptionList = ({
  labels,
  isLoading,
  handleVehicleSelection,
  formValues,
  vehicleOptions,
  bestRates,
  allowWalkOn,
  selectIsWalkOn,
  isWalkOn
}) => {
  return isLoading ? (
    <BrandLoader />
  ) : (
    <div
      className="passenger-vehicles__initial-form"
      data-testid={'vehicle-options-list'}
    >
      {vehicleOptions.map((vehicle, i) => {
        const freeCapacity = bestRates?.[vehicle.resourceCode]?.['freeCapacity']

        if (+freeCapacity < 0) return null

        const isSelected =
          formValues &&
          formValues.vehicleType &&
          formValues.vehicleType.resourceCode === vehicle.resourceCode
        const title = labels[vehicle.resourceCode] || vehicle.resourceCode

        return (
          <button
            key={i}
            className={`passenger-vehicles__initial-form-toggle ${
              isSelected ? 'active' : ''
            }`}
            onClick={() => {
              handleVehicleSelection(vehicle)
            }}
          >
            <div className="toggle-label">
              <p className="u-remove-margin">{title}</p>
            </div>
          </button>
        )
      })}
      {allowWalkOn && (
        <button
          className={`passenger-vehicles__initial-form-toggle ${
            isWalkOn ? 'active' : ''
          }`}
          onClick={selectIsWalkOn}
        >
          <div className="toggle-label">
            <p className="u-remove-margin">{labels.noVehicleMsg}</p>
          </div>
        </button>
      )}
    </div>
  )
}

VehicleOptionList.propTypes = {
  labels: shape().isRequired,
  isLoading: bool.isRequired,
  handleVehicleSelection: func.isRequired,
  formValues: shape().isRequired,
  vehicleOptions: arrayOf(shape()).isRequired,
  bestRates: shape(),
  allowWalkOn: bool.isRequired,
  selectIsWalkOn: func.isRequired,
  isWalkOn: bool.isRequired
}

export default VehicleOptionList
